import { Box, Button, Tooltip } from "@mui/material";

const FormSubmitButton = ({ disabledReason = "", ...buttonProps }) => {
  return (
    <Tooltip title={disabledReason} describeChild arrow>
      <Box
        component="span"
        tabIndex={disabledReason ? 0 : undefined}
        sx={{
          display: "block",
          width: buttonProps.fullWidth ? "100%" : "auto",
        }}
      >
        <Button
          {...buttonProps}
          type={buttonProps.type ?? "submit"}
          disabled={Boolean(disabledReason) || buttonProps.disabled}
        />
      </Box>
    </Tooltip>
  );
};

export default FormSubmitButton;
